import { Injectable } from '@angular/core';
import { resourceAdaptor } from 'qp-adaptor';
import { ContainerVm, Resource } from 'qp-ui-interface';
import { BehaviorSubject, Subject } from 'rxjs';
import { LanguageService } from '../language.service';
import { ErrorFactory } from '../shared/modules/errors/handler/ErrorFactory';
import { BookmarkService } from '../shared/services/bookmark.service';
import { ConfigService } from '../shared/services/config.service';
import { ContentEntitlementService } from '../shared/services/evergent/entitlement/content-entitlement.service';
import { VODDetailsMessage } from '../shared/services/evergent/entitlement/model/entitlement/vod-details.message';
import { FavouriteService } from '../shared/services/favourite.service';
import { MetaDataService } from '../shared/services/meta-data.service';
import { getDeviceType } from '../shared/utils/deviceUtils';
import { ErrorEvents } from '../shared/utils/ErrorUtils';
@Injectable({
  providedIn: 'root',
})
export class MyAhaService {
  private _bookmarks = new BehaviorSubject<ContainerVm>(null);
  private _favourites = new BehaviorSubject<ContainerVm>(null);
  private _rentals = new BehaviorSubject<ContainerVm>(null);
  private _hasData = new Subject<boolean>();

  constructor(
    private languageService: LanguageService,
    private readonly bookmarkService: BookmarkService,
    private readonly favouriteService: FavouriteService,
    private readonly contentEntlmntService: ContentEntitlementService,
    private readonly metadataService: MetaDataService,
    private readonly configService: ConfigService
  ) {}

  get bookmarks$() {
    return this._bookmarks.asObservable();
  }

  get favourites$() {
    return this._favourites.asObservable();
  }

  get rentals$() {
    return this._rentals.asObservable();
  }

  get hasData$() {
    return this._hasData.asObservable();
  }

  getLanguage() {
    return this.languageService.getCurrentWatchLanguage();
  }

  clearData() {
    this._bookmarks.next(null);
    this._favourites.next(null);
    this._rentals.next(null);
  }

  async fetchPageData() {
    const [_fav, _bkmk, _vodEntitlements] = await Promise.all([
      this.favouriteService.getQpFavorites(),
      this.bookmarkService.getQpBookmarks(),
      this.contentEntlmntService.fetchVodEntitlements(),
    ]);
    let rentals: ContainerVm;
    this._favourites.next(_fav?.resources?.length ? _fav : null);
    this._bookmarks.next(_bkmk?.resources?.length ? _bkmk : null);
    if (_vodEntitlements?.length) {
      rentals = await this.fetchRentals(_vodEntitlements);
      this._rentals.next(rentals);
    }

    const hasData =
      (_fav?.resources?.length ||
        _bkmk?.resources?.length ||
        rentals?.resources?.length) > 0;
    this._hasData.next(hasData);
  }

  private async fetchRentals(vodEntitlements: VODDetailsMessage[]) {
    const ids = vodEntitlements.map((it) => it.serviceID);
    const response = await this.metadataService.getResources(ids);
    const formatted = this.formatResources(response, 'Rentals', {
      en: 'My Rentals',
    });
    return formatted;
  }

  private formatResources(
    resources: Resource[],
    name: string,
    containerName: any,
    tabId?: string,
    tabName?: string,
    originScreen?: string
  ) {
    try {
      const imageResizeURL =
        this.configService.applicationConfig.imageResizeURL;
      const containerVm: ContainerVm = {
        id: `cvm-${name}`,
        aspectRatio: '2x3',
        name: `${name}`,
        layout: 'carousel',
        localizedName: {
          en: { n: 'Rentals' },
        },
        resources: resources?.map((res: Resource) => {
          const resource = resourceAdaptor(
            imageResizeURL,
            res,
            getDeviceType(),
            '0-2x3',
            undefined,
            undefined,
            {
              tabId,
              tabName,
              originScreen,
              containerName,
            }
          );
          resource.containerName = containerName;
          return resource;
        }),
      };

      return containerVm;
    } catch (error) {
      // this.newrelicService.onError(error, ErrorEvents.FAVORITE_FETCH_ERROR);
      return Promise.reject(
        ErrorFactory.get(error, ErrorEvents.RESOURCE_FETCH_ERROR)
      );
    }
  }
}
